import type { Setting } from "..";

import GroupComp from "./GroupComp.svelte";
import ColumnsComp from "./ColumnsComp.svelte";

export const Components = {
    "group": GroupComp,
    "columns": ColumnsComp
}

export function getSetting(settings: Setting[], id: string) {
    return settings.find(s => s.id === id)!;
}